module.exports = __webpack_public_path__ + "static/media/Problem_solving.450fb3be.png";